/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { useEffect, useState, KeyboardEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { getCompanies } from '../../services/Companies/getCompanies'

export const useCompanies = () => {
  const navigate = useNavigate()
  const goToPageCompaniesDetails = (id: number) => {
    navigate(`/empresas/${id}`)
  }
  const goToPage = (id: number) => {
    navigate(`/produto/${id}`)
  }

  const [searchValue, setSearchValue] = useState('')
  const [isShowFilter, setIsShowFilter] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [companies, setCompanies] = useState<GetProductsType>(
    {} as GetProductsType
  )
  const [isLoading, setIsLoading] = useState(true)
  const [statusChecked, setStatusChecked] = useState<string[]>([])
  const [statusCheckedTodos, setStatusCheckedTodos] = useState<string[]>([])
  const [statusCheckedFiltro, setStatusCheckedFiltro] = useState<string[]>([])

  const fetchCompanies = async (cancel?: any) => {
    setIsLoading(true)
    const result = await getCompanies(
      cancel,
      searchValue,
      statusCheckedFiltro,
      currentPage
    )
    setIsLoading(false)
    if ('message' in result) {
      if (result.message === 'cancelToken') {
        ;('')
      } else {
        toast.error(result.message)
      }
    } else {
      setCompanies(result)
    }
  }

  const showFilter = () => setIsShowFilter(!isShowFilter)
  const handleCheckboxChange = (option: string) => {
    if (option === 'TODOS') {
      if (statusChecked.includes('TODOS')) {
        setStatusChecked([])
      } else {
        setStatusChecked([])
        setStatusCheckedTodos([])
        localStorage.setItem('filtroStatus', JSON.stringify([]))
      }
    } else if (statusChecked.includes('TODOS')) {
      setStatusChecked([option])
    } else if (statusChecked.includes(option)) {
      setStatusChecked(statusChecked.filter(item => item !== option))
      statusChecked.length === 1
        ? setStatusCheckedTodos([])
        : setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify(statusChecked.filter(item => item !== option))
      )
    } else {
      setStatusChecked([...statusChecked, option])
      setStatusCheckedTodos(['TODOS'])
      localStorage.setItem(
        'filtroStatus',
        JSON.stringify([...statusChecked, option])
      )
    }
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      const source = axios.CancelToken.source()
      fetchCompanies(source)
      return () => {
        source.cancel('cancelToken')
      }
    }
  }

  useEffect(() => {
    const source = axios.CancelToken.source()
    fetchCompanies(source)
    return () => {
      source.cancel('cancelToken')
    }
  }, [currentPage, statusCheckedFiltro])

  return {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    companies,
    fetchCompanies,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    goToPageCompaniesDetails,
    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,
    handleCheckboxChange,
  }
}
